import { get, writable } from 'svelte/store';
import request, { getEndpointUrl } from '@/core/apiRequest/apiRequest';

const globalTagsStorage = writable({
    totalResults: 0,
    pageNumber: 0,
    selectedTags: [],
    tagsForSelection: []
});

export default {
    subscribe: globalTagsStorage.subscribe,
    addTag(tag) {
        globalTagsStorage.update(items => ({
            ...items,
            selectedTags: Array.from(new Set([...items.selectedTags, tag]))
        }));
    },
    removeTag(tag) {
        globalTagsStorage.update(items => ({
            ...items,
            selectedTags: items.selectedTags.filter(t => t !== tag)
        }));
    },
    getTags() {
        const { selectedTags } = get(globalTagsStorage);
        return selectedTags;
    },
    async load(search = '', pageNumber = 0) {
        let textSearch;
        if (search) {
            textSearch = {
                fields: ['tag'],
                fuzziness: true,
                value: search
            };
        }

        const response = await request(getEndpointUrl('searchTags'), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                pageNumber,
                pageSize: 10,
                textSearch
            })
        });
        const newData = response.data.map(tagObject => tagObject.tag);
        globalTagsStorage.update(items => ({
            ...items,
            pageNumber,
            totalResults: response.totalResults,
            tagsForSelection: pageNumber ? items.tagsForSelection.concat(newData) : newData
        }));
    }
};
